import { css } from 'glamor'

export default {
  app: css({
    marginTop: '50px',
    minHeight: '700px',
    background: 'white',
    padding: '15px',
    position: 'relative',
    borderRadius: '30px',

    '@media(min-width: 700px)': {
      margin: '65px 15px 15px',
    },

    '@media(min-width: 1024px)': {
      height: '700px',
      width: '900px',
      padding: '10px 30px',
      marginTop: '5%',
      boxSizing: 'border-box',
    }
  }),

  angle: css({
    width: '64px',
    position: 'absolute',
    display: 'none',
    zIndex: '-1',

    '@media(min-width: 700px)': {
      display: 'block',
    }
  }),
  leftTop: css({
    left: 0,
    top: 0,
  }),
  rightTop: css({
    right: 0,
    top: 0,
    transform: 'scale(-1, 1)',
  }),
  leftBottom: css({
    left: 0,
    bottom: '0px',
    transform: 'scale(1, -1)',
  }),
  rightBottom: css({
    right: 0,
    bottom: '0',
    transform: 'scale(-1, -1)',
  }),
}


// WEBPACK FOOTER //
// ./src/components/App/styles.js